/**
 * The floor tags the Overview frame hands down to the view it hosts (twin
 * slice 1: W2B's floor-list slot, fed from W5G's one attention model).
 *
 * WHY A CONTEXT. The frame owns the one `useAttentionModel` (one debounce,
 * one list), and the Building view is its child -- but rendered by
 * `OverviewScreen`, which sits ABOVE the frame and so cannot read anything
 * the frame computes. A context the frame provides around its child is
 * the one way down that mounts no second model: the Building view reads
 * the tags here and never polls a source of its own.
 *
 * Empty unless the frame's attention list is mounted, i.e. while this
 * viewer's flag is on (`OverviewFrame`). Outside a frame, empty too.
 */
import { createContext, useContext } from 'react';

import { NO_FLOOR_TAGS, type FloorTagGroups } from '../../../state/attention/floor-tags';

export const OverviewFloorTagsContext = createContext<FloorTagGroups>(NO_FLOOR_TAGS);

/** The frame's floor tags: each tagged floor's group. */
export function useOverviewFloorTags(): FloorTagGroups {
  return useContext(OverviewFloorTagsContext);
}
